import * as types from "../actions/actionTypes";
import log from "../utils/log";

export const userSetInformations = (
  login,
  superAdmin,
  targetDirectories,
  token,
  environment,
  accountMetadataLabel,
  uipreferences,
  uploadEnabled
) => {
  log.info("[USER ACTION] USER_SET_INFORMATIONS");
  return {
    type: types.USER_SET_INFORMATIONS,
    login,
    superAdmin,
    targetDirectories,
    token,
    environment,
    accountMetadataLabel,
    uipreferences,
    uploadEnabled
  };
};

export const getConfigurationJsonStart = () => {
  log.info("[USER ACTION] GET_CONFIGURATION_JSON_START");
  return {
    type: types.GET_CONFIGURATION_JSON_START
  };
};

export const getConfigurationJsonEnd = (configuration) => {
  log.info("[USER ACTION] GET_CONFIGURATION_JSON_END");
  return {
    type: types.GET_CONFIGURATION_JSON_END,
    configuration
  };
};

export const getConfigurationJsonEndError = () => {
  log.info("[USER ACTION] GET_CONFIGURATION_JSON_END_ERROR");
  return {
    type: types.GET_CONFIGURATION_JSON_END_ERROR
  };
};



// WEBPACK FOOTER //
// ./src/actions/userActions.js